import React, { memo } from 'react'
import './styles.css'
import { IOrdersByManager } from '../../model/types/types'
import { Table, Typography } from 'antd'
import { HStack } from '../../../../ui/Stack'
import { formatPrice } from '../../../utils'
import { getOrdersByManagerColumns } from './column'

const { Title } = Typography

export interface OrdersByManagersTableProps {
  data?: IOrdersByManager
}

const OrdersByManagers = (props: OrdersByManagersTableProps) => {
  const { data } = props
  if (!data) {
    return <Typography.Text>Сервер не может найти запрошенный ресурс. </Typography.Text>
  }

  return (
    <div>
      {Array.from(data).map(([month, { orders, total }]) => {
        return (
          <Table
            title={() => <Title level={5}>{month}</Title>}
            key={month}
            dataSource={orders}
            columns={getOrdersByManagerColumns(false)}
            pagination={false}
            bordered
            size="small"
            rowKey={(r) => r.key}
            style={{ marginBottom: '40px' }}
            className="orders-by-managers-table"
            footer={() => (
              <HStack justify={'between'} align={'start'} style={{ fontWeight: 'bolder' }} max>
                <span title={`(Всего ${orders.filter(i => !i.manager.includes('Итог')).length}шт)`}>
                  Всего:
                </span>
                <span>{formatPrice(total)}</span>
              </HStack>
            )}
          />
        )
      })}
    </div>
  )
}
export const OrdersByManagersTable = memo(OrdersByManagers)
